import AuthContext from "context/AuthContext";
import { useContext } from "react";
import TabGeneral from "./waste/TabGeneral";
import TabGeneralBridge from "./bridge/TabGeneralBridge";

const TabGeneralManager = ({ item, add, btnDelete, paramsTypes, setFormData, formData }) => {
    const { panel } = useContext(AuthContext);
    switch (panel.panel_type) {
        case "b":
            return <TabGeneralBridge item={item} add={add} btnDelete={btnDelete} paramsTypes={paramsTypes} setFormData={setFormData} formData={formData} />
        default:
            return <TabGeneral item={item} btnDelete={true} paramsTypes={paramsTypes} setFormData={setFormData} formData={formData} />
    };
};

export default TabGeneralManager;